const appConfig = window.appConfig || {};
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  debug: true,
  tokenStorageName: "DMAccessToken",
  credentialsTokenStorage: "DMCredentialToken",
  credentialsRefreshTokenStorage: "DMCredentialsRefreshToken",
  tokenExpireGapMin: 20,
  tokenCheckInterval: 1000 * 60 * 5,
  apiCheckInterval: 5000,
  clientSecret: process.env.OAUTH2_CLIENT_SECRET,
  ...appConfig,
};
